import { Pipe, PipeTransform } from '@angular/core';
import { UtilService } from 'src/app/core';

@Pipe({ name: 'getFileSize' })
export class GetFileSizePipe implements PipeTransform {
  transform(size: number): string {
    return size && !isNaN(size) ? UtilService.formatBytes(size) : '';
  }
}
